import { render, staticRenderFns } from "./OrticFilterNumber.vue?vue&type=template&id=d1c14010&"
import script from "./OrticFilterNumber.vue?vue&type=script&lang=js&"
export * from "./OrticFilterNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports